<template>
  <div class="blast-radio tw-overflow-hidden tw-flex tw-px-px">
    <input
      type="radio"
      :id="id"
      :required="required"
      :name="name"
      :disabled="disabled"
      :value="value"
      v-model="componentModel"
      @change="$emit('change', value)"
      :checked="componentModel === value"
    />
    <label
      class="tw-ml-2 tw-font-thin tw-whitespace-no-wrap tw-overflow-hidden"
      :class="labelClass"
      :for="id"
      v-text="label"
    ></label>
  </div>
</template>

<script>
  import inputMixin from './input';

  export default {
    name: 'BlastRadio',

    mixins: [
      inputMixin,
    ],

    props: {
      model: {
        required: false,
      },

      labelClass: {
        default: 'tw-font-normal',
      },
    },
    watch: {
      model() {
        this.componentModel = this.model;
      }
    },
    data() {
      return {
        componentModel: '',
      };
    },
    mounted() {
      this.componentModel = this.model;
    },
  };
</script>
